export interface DashboardUmParameters {
  meses: string;
  ano: string;
  tiposDeOSFilha: string;
  grupoLocalNivel1Id: number;
  mesDiaInicial: string;
  periodo: string;
  dataInicial: string;
  dataFinal: string;
  tipoOSs: string;
}

export interface EquipamentoComboBoxViewModel {
  id: number;
  nome: string;
}

export interface ParametersPesquisaEquipamento {
  parameter: string;
  valor: string;
  tipoLocal: number;
}

export interface OSTipoViewModel {
  oSId: number;
  tipoOSFilha: number;
  fileNamePdf: string;
  imprimirEvidenciaDeFotos: string;
}

export interface FotoBase64ViewModel {
  base64String: string;
  arquivoNome: string;
}

export interface ParametersOS {
  osId: number;
  spvId: number;
}

export interface DescricaoValorViewModel {
  descricao: string;
  descricaoAbrev: string;
  valor: number;
  valor2?: number;
  valor3?: number;
}

// ----------------------------------------------

export class PodeAcessarViewModel {
  // ajustar alteracoes em login
  constructor(
    public Usuario: boolean,
    public EmitirOS: boolean,
    public EmitirOsAutomatica: boolean,
    public ConsultarOs: boolean,
    public HistoricoEquipamento: boolean,
    public SatisfacaoServico: boolean,
    public Dashboard: boolean,
    public QuantitativoServicos: boolean,
    public Irregularidade: boolean,
    public Empreiteira: boolean,
    public FecharOs: boolean,
    public Fabricante: boolean,
    public Estoque: boolean,
    public Material: boolean,
    public Categoria: boolean,
    public Funcionario: boolean,
    public Equipamento: boolean,
    public Local: boolean,
    public AreaTecnica: boolean,

    public Rotina: boolean,
    public Atividade: boolean,
    public UsuarioAlterarSenha: boolean,
    public SolicitarSpv: boolean,
    public AcompanharSpv: boolean,
    public AvaliarSpv: boolean,
    public ProgramarServico: boolean,
    public SolicitarPt: boolean,
    public AcompanharPt: boolean,

    public CentroCusto: boolean,
    public ClasseEquipamento: boolean,
    public GrupoLocalNivel: boolean,
    public Prioridade: boolean,
    public TipoMaterial: boolean,
    public EquipamentoRD: boolean,
    public ModeloRD: boolean,
    public EmitirRD: boolean,
    public CalendarioMensal: boolean,
    public EntradaMaterial: boolean,
    public EntradaPeriodo: boolean,
    public TratarOSAvaliada: boolean,
    public VistoDeExecucao: boolean,
    public ValidarOS: boolean
  ) { }
}
